import client from '../../shared/api/client';
import { AuditLog, PaginatedResponse } from '../../shared/types';

export const getAuditLogs = async (params?: {
  page?: number;
  per_page?: number;
  action?: string;
  entity_type?: string;
  admin_id?: number;
  from?: string;
  to?: string;
}): Promise<PaginatedResponse<AuditLog>> => {
  const response = await client.get<PaginatedResponse<AuditLog>>('/audit-logs', { params });
  return response.data;
};

export const getAuditLog = async (id: number): Promise<AuditLog> => {
  const response = await client.get<AuditLog>(`/audit-logs/${id}`);
  return response.data;
};
